var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.productReplenishmentSelectV3 = {
    attach: function (context) {
      var $template = $('.js-product-replenishment-select-v3', context);
      var $atbWrapper = $('.js-product-full-v3, .js-product-full-v4, .js-sticky-add-to-bag', context);
      var $addBtn = $('.js-add-to-cart', $atbWrapper).not('.js-use-with-atb');
      var $replenishmentOneTime = $('.js-replenishment-one-time', $template);
      var $replenishmentAutoRadio = $('.js-auto-delivery-input', $template);
      var $replenishmentOption = $('.js-replenishment-option', $template);
      var $overlayTrigger = $('.js-replenishment-overlay-link', $template);
      var $replenishmentAuto = $('.js-replenishment-auto-delivery', $template);
      var $replenishmentAutoOptions = $('.js-replenishment-auto-options', $template);
      var $replenishmentSelectedOption = $('.js-replenishment-option-selected', $template);
      var $replenishmentTextSeperator = $('.js-replenishment-seperator', $template);
      var subscribeText = $replenishmentAutoRadio.data('subscribe-text');

      /* @todo - trigger update on sku change if needed
         Add replenishment menu event if enable_replenishment=true in config.
      */
      if (!Drupal.settings.product_display || !Drupal.settings.product_display.has_replenishment) {
        return null;
      }

      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isMobile = currentBpWidth <= bPportraitUp;

      $replenishmentAuto.on('keydown', function (e) {
        if (e.key === 'Enter') {
          $(this).trigger('click');
        }
      });

      $replenishmentAuto.once().on('click', function (e) {
        var $html = $('html');
        var isExpanded = $replenishmentAuto.hasClass('expanded');
        var options;

        if (
          $(e.target).hasClass('js-auto-delivery-input') &&
          $replenishmentAuto.hasClass('active')
        ) {
          return;
        }
        if (isExpanded && $replenishmentSelectedOption.text() !== '') {
          $replenishmentAutoOptions.addClass('hidden').removeClass('show-overlay');
          $replenishmentAuto.removeClass('expanded').addClass('collapsed');
          $replenishmentAutoRadio.prop('checked', true);
        } else {
          $replenishmentAuto.addClass('expanded').removeClass('collapsed');
          $addBtn.attr(
            'data-replenishment',
            $replenishmentSelectedOption.attr('data-replenishment')
          );
          if (isMobile) {
            options = {
              content: $replenishmentAutoOptions.clone(true).removeClass('hidden'),
              className: 'product-replenishment-auto__options show-overlay',
              bottom: 0,
              fixed: 'true',
              includeBackground: true,
              maxHeight: 350,
              top: 'auto',
              onComplete: function () {
                $html.addClass('overlay-open');
              },
              onClosed: function () {
                $html.removeClass('overlay-open');
                $addBtn.attr(
                  'data-replenishment',
                  $replenishmentSelectedOption.attr('data-replenishment')
                );
              }
            };

            generic.overlay.launch(options);
          } else {
            $replenishmentAutoOptions.removeClass('hidden');
          }
        }
        $replenishmentAuto.addClass('active');
      });

      $replenishmentOneTime.once().on('click', function () {
        $addBtn.attr('data-replenishment', 0);
        $replenishmentAutoOptions.add($replenishmentTextSeperator).addClass('hidden');
        $replenishmentAuto.removeClass('expanded').addClass('collapsed');
        $replenishmentAuto.removeClass('active');
      });

      // Launch product_auto_replenishment partial in overlay
      function launchOverlay() {
        var $html = $('html');
        var $productReplenishmentInfo;
        var rendered;

        if (
          Boolean(site) &&
          Boolean(site.templates) &&
          site.templates['product_replenishment_info_v1'] !== undefined
        ) {
          rendered = site.template.get({
            name: 'product_replenishment_info_v1'
          });
          $productReplenishmentInfo = $('.js-product-replenishment-info--v1', rendered);
          generic.overlay.launch({
            content: rendered,
            width: '679px',
            height: $productReplenishmentInfo.outerHeight(true),
            fixed: 'true',
            className: 'product-replenishment-info__popup',
            onComplete: function () {
              $html.addClass('overlay-open');
            },
            onClosed: function () {
              $html.removeClass('overlay-open');
              $overlayTrigger.focus();
            }
          });
        }
      }

      $overlayTrigger.once().on('click keydown', function (e) {
        if (e.type === 'click' || e.key === 'Enter') {
          launchOverlay();
        }
      });

      /* When the replenishment select changes,
         Update the add-to-bag button's data-replenishment value.
      */
      $replenishmentOption.once().on('click keydown', function (e) {
        var $this = $(this);
        var repValue = $('.js-replenishment-auto-option', $this).val();
        var replenishmentSelectText = $this.text().trim();
        var ariaLabelText = $replenishmentAutoRadio.data('aria-label-text');

        if (e.key === 'Enter' || e.type === 'click') {
          $addBtn.add($replenishmentSelectedOption).attr('data-replenishment', repValue);
          $replenishmentSelectedOption.text(replenishmentSelectText);
          $replenishmentTextSeperator.add($replenishmentSelectedOption).removeClass('hidden');
          $replenishmentAutoRadio
            .attr('aria-label', ariaLabelText + ' ' + replenishmentSelectText)
            .prop('checked', true)
            .focus();
          $replenishmentAuto.removeClass('expanded').addClass('collapsed');
          if (isMobile) {
            generic.overlay.hide();
          } else {
            $replenishmentAutoOptions.addClass('hidden');
          }
          if (Boolean(subscribeText)) {
            $('.js-auto-replenishment-label', $replenishmentAuto).text(subscribeText);
          }
          $replenishmentAutoRadio.focus();
        }
      });

      // Close auto-replenish dropdown when clicked outside
      $(document).on('click', function (e) {
        var isExpanded = $replenishmentAuto.hasClass('expanded');

        if (isExpanded) {
          if ($(e.target).closest($replenishmentAuto).length === 0) {
            $replenishmentAutoRadio.prop('checked', true);
            $replenishmentAuto.removeClass('expanded').addClass('collapsed');
            $replenishmentAutoOptions.addClass('hidden');
          }
        }
      });

      $addBtn.attr('data-replenishment', '0');
    }
  };
})(jQuery);
